import React, { useState, useMemo, useRef, useEffect } from 'react';
import { getCachedStates } from '../../utils/statesCache';
import { toastNotify } from '../../utils/toastNotify';
import { Select, Spin, Form } from 'antd';
import { ChevronDown, ChevronUp } from '../../assets/icons';
import FloatingLabel from '../FloatingLabel/FloatingLabel';

const StateSeeder = (props) => {
  const { value, setState, isEdit, required, setStateName, name = 'state', inputId = 'state', label = 'State', disabled = false } = props;
  const [stateLoader, setStateLoader] = useState(false);
  const [totalStates, setTotalStates] = useState(0);
  const [stateDataList, setStateDataList] = useState([]);
  const [statePage, setStatePage] = useState(1);
  const [arrowUp, setArrowUp] = useState(false);
  const selectRef = useRef();

  useEffect(() => {
    if (statePage === 0) {
      // Fetch state data only when statePage is 1 (component mount)
      fetchStateData(statePage);
    }
  }, []);
  
  const fetchStateData = async (page) => {
    setStateLoader(true);
    try {
      const resp = await getCachedStates(page, 100);
      if (!resp.isError) {
        setTotalStates(resp?.data?.count);
        resp?.data?.states?.forEach((item) => {
          setStateDataList((prevItem) => [...prevItem, item]);
        });
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setStateLoader(false);
    }
  };

  useMemo(() => fetchStateData(statePage), []);

  const incrementPagination = () => {
    setStatePage((statePage) => statePage + 1);
    fetchStateData(statePage + 1);
  };

 const handleStateChange = (selectedStateId) => {
  const selectedState = stateDataList.find((state) => state.stateId === selectedStateId);
  if (selectedState) {
    setState(selectedStateId);
    setStateName?.(selectedState.name);
    if (selectRef.current) {
      selectRef.current.blur?.();
    }
  }
};


  return (
    <FloatingLabel label={label} inputId={inputId} name={name} isEdit={isEdit} inputValue={value}>
      <>
        <div id={`${inputId}-seeder-anchor`} />
        <Form.Item name={name} rules={[{ required: required, message: 'Please select state' }]} validateTrigger="onBlur">
          <Select
            id={inputId}
            ref={selectRef}
            onChange={handleStateChange}
            value={value}
            disabled={disabled}
            getPopupContainer={() => document.getElementById(`${inputId}-seeder-anchor`)}
            onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
            suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
            onPopupScroll={(e) => {
              let target = e.target;
              if (target.scrollTop + target.offsetHeight === target.scrollHeight && totalStates > stateDataList.length && !stateLoader) {
                incrementPagination();
              }
            }}
          >
            {stateDataList.map((state, index) => (
              <Select.Option key={index} value={state.stateId}>
                <span>{state.name}</span>
              </Select.Option>
            ))}
            {stateLoader && (
              <Select.Option disabled>
                <Spin className='ant-spin--centered' />
              </Select.Option>
            )}
          </Select>
        </Form.Item>
      </>
    </FloatingLabel>
  );
};

export default StateSeeder;
